import { render } from "./service-form.vue?vue&type=template&id=bff42968"
import script from "./service-form.vue?vue&type=script&lang=js"
export * from "./service-form.vue?vue&type=script&lang=js"

import "./service-form.vue?vue&type=style&index=0&id=bff42968&lang=scss"

import exportComponent from "/data/project/activity-v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__